module.exports = __webpack_public_path__ + "static/media/ADD TO FAV.eb405031.svg";